<app-modal
  [isActive]="isActive"
  [isLarge]="true"
  [showCloseFooter]="false"
  (modalState)="closeModal.emit()"
>
  <p class="modal-card-title" modal-title>
    <span class="is-capitalized"> {{ 're-route.modal.title' | translate }} </span>
  </p>

  <form [formGroup]="form" (ngSubmit)="submit()" modal-content>
    <p class="modal-card-title" modal-title *ngIf="showInfantWarning || !validPassengers">
      <em class="mdi mdi-message-alert has-text-warning mdi-18px" aria-hidden="true"></em>
      {{ 'shared.warning' | translate }}
    </p>
    <br />
    <div *ngIf="!validPassengers" class="alert alert-warning" role="alert">
      {{ 're-route.invalid-passengers' | translate }}
    </div>
    <br />
    <div *ngIf="showInfantWarning" class="alert alert-warning" role="alert">
      {{ 'layout.alert-messages.infant-reassignment' | translate }}
    </div>

    <div class="columns">
      <div *ngIf="aditionalFieldsConfig?.waiverEnabled" class="column">
        <app-input-field
          [form]="form"
          type="text"
          inputName="waiver"
          [label]="'re-route.modal.waiver' | translate"
          [placeholder]="'re-route.modal.waiver' | translate"
          [errorMessage]="'re-route.modal.waiver-required' | translate"
        ></app-input-field>
      </div>

      <div *ngIf="aditionalFieldsConfig?.tourcodeEnabled && !isAirline" class="column">
        <app-input-field
          [form]="form"
          type="text"
          inputName="tourCode"
          [label]="'re-route.modal.tourcode' | translate"
          [placeholder]="'re-route.modal.tourcode' | translate"
          [errorMessage]="'re-route.modal.tourcode-required' | translate"
        ></app-input-field>
      </div>

      <div *ngIf="aditionalFieldsConfig?.tourcodeEnabled && isAirline" class="column">
        <app-input-select
          [form]="form"
          inputName="tourCode"
          [values]="tourCodes"
        ></app-input-select>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <app-select-and-field
          *ngIf="aditionalFieldsConfig?.osiEnabled"
          inputNameTickets="ticketNumbers"
          inputNameType="searchType"
          id="osi"
          label="OSI"
          [form]="form"
          [isGenericSelectAndFieldComponent]="true"
          [genericPlaceholder]="'OSI'"
          (addControl)="addOSIToForm($event)"
          (deleteControl)="deleteOSI($event)"
          [errorMessage]="'dashboard.booking-search.submit-error' | translate"
        ></app-select-and-field>
      </div>
    </div>
  </form>

  <div class="columns" modal-footer>
    <div class="column is-3 is-offset-9">
      <app-input-submit
        inputText="{{ 'shared.continue' | translate }}"
        type="submit"
        [disabled]="disabledContinueButton()"
        (clickButton)="submit()"
      ></app-input-submit>
    </div>
  </div>
</app-modal>
